import React from 'react';
import PropTypes from 'prop-types'
import { Icon } from '@paypalcorp/pp-react';

export default function RecurringInfo({ helpText1, helpText2 }) {
	return (
		<div className="ppvx_text--sm recurring-info">
			<div className="icon">
				<Icon name="info" size="sm" />
			</div>
			<div className="content">
				<p className="line1" dangerouslySetInnerHTML={{ __html: helpText1 }}></p>
				<p className="line2" dangerouslySetInnerHTML={{ __html: helpText2 }}></p>
			</div>

			
		</div>
	)
}

RecurringInfo.propTypes = {
	helpText1: PropTypes.string,
	helpText2: PropTypes.string
};
